import { useAuthStore } from '@centric-os/stores/auth/use-auth-store';
import { useSplitIoStore } from '@centric-os/stores/splitio/use-split-io';
import { FeatureFlags, P2Role } from '@centric-os/types';
import { SitesRouteNames } from '@centric-os/sites/src/enums';
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

/**
 * Gates the vendors section behind the VIEW_VENDORS feature flag and the
 * super-admin role, redirecting to the sites list otherwise. Mirrors the
 * loyalty/discover guards.
 */
export const beforeEnter = async (
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const splitIoStore = useSplitIoStore();
  const authStore = useAuthStore();

  try {
    // `isFeatureOn` reads the fetched flags, so fetch first (idempotent) to
    // resolve the flag on a deep-link or refresh before deciding.
    if (!splitIoStore.initialized) {
      await splitIoStore.fetchFeatureFlags();
    }

    const canAccess =
      authStore.hasRole(P2Role.SUPER_ADMIN) && splitIoStore.isFeatureOn(FeatureFlags.VIEW_VENDORS);

    if (canAccess) {
      next();
    } else {
      next({ name: SitesRouteNames.SITES_LIST, replace: true });
    }
  } catch (error) {
    console.error('Error during navigation guard execution:', error);
    next(false);
  }
};
